import { makeStyles } from "@mui/styles";
import { Bold, SemiBold } from "../../../utils";

export const ContractCreateEditStyle = makeStyles((theme) => ({
    selectedContractLabel: {
        fontSize:"1rem",
        color: theme.typography.color.primary,
        fontFamily: Bold
    },
    createBtn: {
        height: 42
    },
    dot: {
        height: "6px",
        width: 6,
        borderRadius: "50%",
        background: theme.typography.color.tertiary,
        marginInline: "8px"
    },
    viewSecondary: {
        fontSize:"0.75rem",
        fontFamily: SemiBold,
        color: theme.typography.color.tertiary
    },
    viewHeaderText:{
        fontSize:"1rem",
        fontFamily: Bold,
        color: theme.typography.color.primary
    }
}))
